import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import '../Pagination.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { runMdMutation, isMdMutationLocked } from '../../services/mdMutationGuard';
import { MD_PAGE_SIZE, fetchAndApplyIndexPage } from '../../services/mdServerIndex';
import { ConfirmDialog } from '../common/ConfirmDialog';
import {
  buildStandardRowActions,
  MdRowActions,
  MdTableActionsCell,
  MdTableCell,
  MdTableHeaderCell,
} from '../common/MdRowActions';
import { SearchIcon } from '../common/mdPageIcons';

function getResultadoBadgeClass(rawResultado) {
  const value = (rawResultado || '').trim();
  if (value === 'Aprobó') return 'md-page__badge md-page__badge--success';
  if (value === 'Reprobó') return 'md-page__badge md-page__badge--danger';
  if (value === 'Ausente') return 'md-page__badge md-page__badge--neutral';
  return 'md-page__badge md-page__badge--neutral';
}

export class MDHistoriaAcademicaExamen extends Component {
  static displayName = MDHistoriaAcademicaExamen.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      searchInput: '',
      perPage: MD_PAGE_SIZE,
      paginationData: [],
      totalCount: 0,
      pageCount: 0,
      offset: 0,
      currentPage: 0,
      showErrorMessage: false,
      errorMessage: '',
      successMessage: '',
      deletingId: null,
      pendingDelete: null,
    };
    this.searchInputRef = React.createRef();
  }

  componentDidMount() {
    if (constantClass.canAccess('HistoriaAcademicaExamen')) {
      this.populateData();
    }
  }

  handleRemoveItem = (periodo) => {
    if (isMdMutationLocked(this)) return;
    this.setState({
      pendingDelete: {
        id: periodo.historiaAcademicaExamenCod,
        nombre: periodo.alumnoNombre + ' — ' + periodo.materia,
      },
    });
  };

  handleCancelDelete = () => {
    if (this.state.deletingId) return;
    this.setState({ pendingDelete: null });
  };

  handleConfirmDelete = () => {
    const { pendingDelete } = this.state;
    if (!pendingDelete || isMdMutationLocked(this)) return;
    this.deleteItem(pendingDelete.id);
  };

  handlePageClick = (e) => {
    this.populateData(e.selected, this.state.searchInput);
  };

  handleSearchInputChange = (e) => {
    const searchInput = e.target.value;
    const cleared = searchInput.trim() === '';
    this.setState({ searchInput, successMessage: '', showErrorMessage: false, errorMessage: '' });
    if (cleared && this.state.searchInput.trim() !== '') {
      this.populateData(0, '', { background: false });
    }
  };

  clearFeedback = () => {
    this.setState({ successMessage: '', showErrorMessage: false, errorMessage: '' });
  };

  handleSearchSubmit = (e) => {
    e.preventDefault();
    const search = (this.searchInputRef.current
      ? this.searchInputRef.current.value
      : this.state.searchInput).trim();
    this.setState({ searchInput: search });
    this.populateData(0, search, { background: false });
  };

  renderTable(periodos) {
    return (
      <div className="md-page__table-card">
        <table className="md-page__table md-page__table--actions-fixed md-hex__table" aria-labelledby="md-historia-academica-examen-title">
          <colgroup>
            <col className="md-hex__col-alumno" />
            <col className="md-hex__col-carrera" />
            <col className="md-hex__col-materia" />
            <col className="md-hex__col-fecha" />
            <col className="md-hex__col-nota" />
            <col className="md-hex__col-resultado" />
            <col className="md-hex__col-actions" />
          </colgroup>
          <thead>
            <tr>
              <MdTableHeaderCell cellType="text" className="md-hex__cell md-hex__cell--alumno">Alumno</MdTableHeaderCell>
              <MdTableHeaderCell cellType="text" className="md-hex__cell md-hex__cell--carrera">Carrera</MdTableHeaderCell>
              <MdTableHeaderCell cellType="text" className="md-hex__cell md-hex__cell--materia">Materia</MdTableHeaderCell>
              <MdTableHeaderCell cellType="date" className="md-hex__cell md-hex__cell--fecha">Fecha Examen</MdTableHeaderCell>
              <MdTableHeaderCell cellType="number" className="md-hex__cell md-hex__cell--nota">Nota</MdTableHeaderCell>
              <MdTableHeaderCell cellType="text" className="md-hex__cell md-hex__cell--resultado md-page__table__badge-cell">Resultado</MdTableHeaderCell>
              <th scope="col" className="md-page__table__actions-header" aria-label="Acción" />
            </tr>
          </thead>
          <tbody>
            {periodos.map((periodo) => (
              <tr key={periodo.historiaAcademicaExamenCod}>
                <MdTableCell cellType="text" className="md-hex__cell md-hex__cell--alumno">{periodo.alumnoNombre}</MdTableCell>
                <MdTableCell cellType="text" className="md-hex__cell md-hex__cell--carrera">{periodo.carrera}</MdTableCell>
                <MdTableCell cellType="text" className="md-hex__cell md-hex__cell--materia">{periodo.materia}</MdTableCell>
                <MdTableCell cellType="date" className="md-hex__cell md-hex__cell--fecha">{constantClass.formatDisplayDate(periodo.historiaAcademicaFechaExamen)}</MdTableCell>
                <MdTableCell cellType="number" className="md-hex__cell md-hex__cell--nota">
                  {periodo.historiaAcademicaExamenNota > 0 ? periodo.historiaAcademicaExamenNota : ''}
                </MdTableCell>
                <MdTableCell cellType="text" className="md-hex__cell md-hex__cell--resultado md-page__table__badge-cell">
                  <span className={getResultadoBadgeClass(periodo.historiaAcademicaExamenResulta)}>
                    {periodo.historiaAcademicaExamenResulta}
                  </span>
                </MdTableCell>
                <MdTableActionsCell>
                  <MdRowActions
                    items={buildStandardRowActions({
                      editTo: '/update-hex/' + periodo.historiaAcademicaExamenCod + '/0',
                      onDelete: () => this.handleRemoveItem(periodo),
                      deleteDisabled: this.state.loading || this.state.deletingId === periodo.historiaAcademicaExamenCod,
                      deleteLabel: this.state.deletingId === periodo.historiaAcademicaExamenCod ? 'Eliminando...' : 'Borrar',
                      detailTo: '/update-hex/' + periodo.historiaAcademicaExamenCod + '/1',
                    })}
                  />
                </MdTableActionsCell>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const isBusy = this.state.loading || this.state.searching;
    const listLoading = this.state.loading && !this.state.deletingId;
    const { pendingDelete } = this.state;

    const contents = listLoading
      ? <p className="md-page__loading"><em>Cargando datos...</em></p>
      : this.renderTable(this.state.paginationData);

    return (
      <div className="md-page md-historia-academica-examen">
        <h1 id="md-historia-academica-examen-title" className="md-page__title">
          Manejar Datos de Historias Académicas de Examen
        </h1>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">
              {this.state.errorMessage}
            </div>
          ) : null}
          {this.state.successMessage ? (
            <div className="md-page__success">{this.state.successMessage}</div>
          ) : null}
        </div>

        <form className="md-page__search-row" onSubmit={this.handleSearchSubmit}>
          <div className="md-page__search-wrap">
            <span className="md-page__search-icon">
              <SearchIcon />
            </span>
            <input
              ref={this.searchInputRef}
              className="md-page__search-input"
              type="text"
              name="search"
              autoComplete="off"
              disabled={isBusy}
              placeholder="Ingrese Nombre del Alumno"
              value={this.state.searchInput}
              onChange={this.handleSearchInputChange}
            />
          </div>
          <button type="submit" className="md-page__search-btn" disabled={isBusy}>
            Buscar
          </button>
        </form>

        {contents}

        {!listLoading && this.state.pageCount > 0 ? (
          <div className="md-page__pagination">
            <ReactPaginate
              previousLabel="Anterior"
              nextLabel="Siguiente"
              breakLabel="..."
              breakClassName="break-me"
              pageCount={this.state.pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              forcePage={Math.floor(this.state.offset / this.state.perPage)}
              onPageChange={this.handlePageClick}
              containerClassName="pagination"
              subContainerClassName="pages pagination"
              activeClassName="active"
            />
          </div>
        ) : null}

        <ConfirmDialog
          open={Boolean(pendingDelete)}
          title="Eliminar historia académica"
          message="Esta acción eliminará el registro de historia académica y no se puede deshacer."
          detail={pendingDelete ? pendingDelete.nombre : ''}
          confirmLabel="Eliminar"
          cancelLabel="Cancelar"
          variant="danger"
          loading={Boolean(this.state.deletingId)}
          onConfirm={this.handleConfirmDelete}
          onCancel={this.handleCancelDelete}
        />
      </div>
    );
  }

  async populateData(page = 0, search = '', options = {}) {
    await fetchAndApplyIndexPage(this, {
      indexUrl: 'api/hex/Index',
      page,
      search: typeof search === 'string' ? search.trim() : '',
      perPage: this.state.perPage,
      background: options.background,
    });
  }

  async deleteItem(id) {
    this.clearFeedback();
    this.setState({ deletingId: id });
    await runMdMutation(this, async () => {
      const { data } = await constantClass.apiFetch('api/hex/delete/' + id, {
        method: 'POST',
      });
      if (data === 'Timeout') {
        constantClass.RedirectToLogin();
        return;
      }
      if (constantClass.isApiError(data)) {
        this.setState({
          showErrorMessage: true,
          errorMessage: constantClass.getApiErrorMessage(
            data,
            'No se pudo eliminar el registro. Intente nuevamente.'
          ),
          pendingDelete: null,
        });
        return;
      }
      this.setState({ successMessage: 'El registro se eliminó correctamente.', pendingDelete: null });
      await this.populateData(this.state.currentPage, this.state.searchInput);
    });
    this.setState({ deletingId: null });
  }
}
